<template>
  <div class="input">
    <Icon
      class="icon"
      name="magnifier"
      size="24" />
    <input
      :type="type"
      :value="value"
      :placeholder="placeholder"
      @input="$emit('input', $event.target.value)" />
  </div>
</template>

<script>

export default {
  props: {
    type: {
      type: String,
      default: 'text',
    },
    placeholder: {
      type: String,
      default: 'Placeholder',
    },
    value: {
      type: [String, Number],
    },
  },
  data() {
    return {

    };
  },
}
</script>
